import { createSlice } from "@reduxjs/toolkit";
import stringUtils from "../../../../_services/string-utils";
import { InitialIntegrationReducer } from "../../../_services/store/InitialIntegrationReducer";
import { integrationReducerActions } from "../../../_commons/integration.reducer";

export const initialNewConfiguration = {
    clientUUID: "",
    basicAuthKey: "",
    basicAuthSecret: "",
    shopName: "",
    useExistingSettingsClientUUID: null,
    useExistingSettings: false,
    autoSetup: true,
};

export const initialDeleteConfigurationRequest = {
    externalUUID: "",
    clientUUID: "",
    deleteConnectedAuthData: false,
};

export const initialAboutYouReducer = {
    ...new InitialIntegrationReducer(),
    newConfiguration: { ...initialNewConfiguration },
    deleteConfigurationRequest: { ...initialDeleteConfigurationRequest },
    importData: null,
};

const aboutYouSlice = createSlice({
    name: "About You",
    initialState: initialAboutYouReducer,
    reducers: {
        ...integrationReducerActions,
        setDeleteConfigurationRequest(state, action) {
            state.deleteConfigurationRequest = action.payload;
        },
        deleteConfigurationRequest(state) {
            state.isDeleteLoading = true;
            state.deleteErrorMessage = null;
            state.successMessage = null;
        },
        deleteConfigurationSuccess(state, action) {
            state.configurations = [...state.configurations].filter(
                (configuration) => !stringUtils.equals(configuration.externalUUID, action.payload.externalUUID)
            );
            state.configurationToBeDeleted = null;
            state.deleteConfigurationModal = false;
            state.isDeleteLoading = false;
            state.successMessage = "Integration gelöscht";
        },
        deleteConfigurationFailure(state, action) {
            state.isDeleteLoading = false;
            state.deleteErrorMessage = action.payload;
        },

        resetEditConfigurationToConfiguration(state) {
            state.editConfiguration = state.configuration;
        },

        startPreImportRequest(state) {
            state.importData = null;
            state.isImportLoading = true;
            state.importErrorMessage = null;
            state.importSuccessMessage = null;
            state.updateErrorMessage = null;
        },
        startPreImportSuccess(state, action) {
            state.importData = action.payload;
            state.isImportLoading = false;
        },
        startPreImportFailure(state, action) {
            state.importData = null;
            state.isImportLoading = false;
            state.importErrorMessage = action.payload;
        },

        startFullImportRequest(state) {
            state.isImportLoading = true;
            state.importData = null;
            state.importSuccessMessage = null;
            state.importErrorMessage = null;
        },
        startFullImportSuccess(state) {
            state.isImportLoading = false;
            state.importSuccessMessage =
                "Buchungsstapel wird erzeugt, Du erhältst eine E-Mail wenn der Abruf abgeschlossen ist.";
        },
        startFullImportFailure(state, action) {
            state.isImportLoading = false;
            state.importErrorMessage = action.payload;
        },

        setSubmitted(state, action) {
            state.submitted = action.payload;
        },

        resetSuccessMessages(state) {
            state.successMessage = null;
        },
        resetUpdateErrorMessage(state) {
            state.updateErrorMessage = null;
        },
    },
});

export default aboutYouSlice;
